module.exports = __webpack_public_path__ + "img/shipping.e6a05819.svg";